/*
Purpose: list details of student with use datatable
Developer: BY KTH
Date:24/05/2025 
Project: TCMS
*/

import { useState, useCallback, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Row, Col, Tab, Nav, Card, Form, Modal } from "react-bootstrap";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Button as Buttonmui } from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import AddIcon from "@mui/icons-material/Add";

import { useFormik } from "formik";
import * as yup from "yup";

import axios from "axios";
import { security_key, BASE_URL } from "../global";
import Moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";

import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";

const StudentYearLevel = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const handleStudentViewClick = async (e) => {
    if (parseInt(e.visibility) == 1) {
      navigate(`/student-profile`, {
        state: { pk_student_key: `${e.pk_student_key}` },
      });
    } else {
      toast.error("Sorry! Allow only active student.", {
        autoClose: 700, // 3 seconds in this example
      });
    }
  };

  //Api call start

  const [data, setItems] = useState([]);
  const [dataDeactive, setDeactiveItems] = useState([]);
  const [records, setRecords] = useState(data);
  const hasRows = records.length > 0;
  const [Deactiverecords, setDeactiveRecords] = useState(dataDeactive);

  const [ShowPopupLevel, setShowPopupLevel] = useState(false);
  const [type, setType] = useState(1);
  const openPopup = (type) => {
    setType(type);
    setShowPopupLevel(!ShowPopupLevel);
  };
  const [isStudentLevelRequestSubmitting, setStudentLevelRequestSubmitting] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(BASE_URL + "API/api_index.php", {
        security_key: security_key,
        mode: "getAllStudentYear",
        fk_cent_key: sessionStorage.getItem("key"),
      });

      if (response.data.success === true) {
        setRecords(response.data.data);
        setItems(response.data.data);
        setLoading(false);
      } else {
        //alert message provide
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    try {
      const response_deactive = await axios.post(
        BASE_URL + "API/api_index.php",
        {
          security_key: security_key,
          mode: "getAllStudentDeactiveWithCard",
          fk_cent_key: sessionStorage.getItem("key"),
        }
      );

      if (response_deactive.data.success === true) {
        setDeactiveRecords(response_deactive.data.data);
        setDeactiveItems(response_deactive.data.data);
        setLoading(false);
      } else {
        //alert message provide
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //Api call End

  // Sample columns configuration
  const columns = [
    {
      headerName: "ID#",
      field: "pk_student_id",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Student Name",
      field: "Student Name",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.st_first_name || ""} ${params.row.st_surname || ""
          }`;
      },
    },
    {
      headerName: "Student Nickname",
      field: "Student Nickname",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.st_nickname || "-"}`;
      },
    },
    {
      headerName: "User Name",
      field: "sa_login_id",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.sa_login_id == null || params.row.sa_login_id == ""
          ? "-"
          : params.row.sa_login_id
          }`;
      },
    },
    {
      headerName: "Parents / Guardians",
      field: "st_is_adultlearner",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.st_is_adultlearner == 1
          ? "Adult Learner"
          : params.row.par_firstname == null || params.row.par_firstname == ""
            ? "-"
            : params.row.par_firstname + " " + params.row.par_surname
          }`;
      },
    },
    {
      id: "dob",
      headerName: "Date Of Birth",
      field: "st_dob",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.st_dob == null || params.row.st_dob == ""
          ? "-"
          : Moment(params.row.st_dob, "YYYY-MM-DD").format("DD-MM-YYYY")
          }`;
      },
      sortComparator: (valueA, valueB, rowA, rowB, direction) => {
        if (valueA === "-" || valueB === "-") {
          // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
          return valueA === valueB ? 0 : valueA === "-" ? 1 : -1;
        }

        const dateA = Moment(valueA, "DD-MM-YYYY");
        const dateB = Moment(valueB, "DD-MM-YYYY");

        return direction === "asc" ? dateA - dateB : dateB - dateA;
      },
    },
    {
      headerName: "Gender",
      field: "st_gender",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.st_gender == null || params.row.st_gender == ""
          ? "-"
          : params.row.st_gender
          }`;
      },
    },
    {
      headerName: "Year Level",
      field: "level_name",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.level_name == null || params.row.level_name == ""
          ? "-"
          : params.row.level_name
          }`;
      },
    },

  ];

  // const columnsDeactive = [
  //   {
  //     headerName: "ID#",
  //     field: "pk_student_id",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //   },

  //   {
  //     headerName: "Student Name",
  //     field: "Student Name",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.st_first_name || ""} ${params.row.st_surname || ""
  //         }`;
  //     },
  //   },
  //   {
  //     headerName: "Student Nickname",
  //     field: "Student Nickname",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.st_nickname || "-"}`;
  //     },
  //   },
  //   {
  //     headerName: "User Name",
  //     field: "sa_login_id",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.sa_login_id == null || params.row.sa_login_id == ""
  //           ? "-"
  //           : params.row.sa_login_id
  //         }`;
  //     },
  //   },
  //   {
  //     headerName: "Parents / Guardians",
  //     field: "st_is_adultlearner",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.st_is_adultlearner == 1
  //           ? "Adult Learner"
  //           : params.row.par_firstname == null || params.row.par_firstname == ""
  //             ? "-"
  //             : params.row.par_firstname + " " + params.row.par_surname
  //         }`;
  //     },
  //   },
  //   {
  //     id: "dob",
  //     headerName: "Date Of Birth",
  //     field: "st_dob",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.st_dob == null || params.row.st_dob == ""
  //           ? "-"
  //           : Moment(params.row.st_dob, "YYYY-MM-DD").format("DD-MM-YYYY")
  //         }`;
  //     },
  //     sortComparator: (valueA, valueB, rowA, rowB, direction) => {
  //       if (valueA === "-" || valueB === "-") {
  //         // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
  //         return valueA === valueB ? 0 : valueA === "-" ? 1 : -1;
  //       }

  //       const dateA = Moment(valueA, "DD-MM-YYYY");
  //       const dateB = Moment(valueB, "DD-MM-YYYY");

  //       return direction === "asc" ? dateA - dateB : dateB - dateA;
  //     },
  //   },
  //   {
  //     headerName: "Gender",
  //     field: "st_gender",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.st_gender == null || params.row.st_gender == ""
  //           ? "-"
  //           : params.row.st_gender
  //         }`;
  //     },
  //   },
  //   {
  //     headerName: "Year Level",
  //     field: "level_name",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.level_name == null || params.row.level_name == ""
  //           ? "-"
  //           : params.row.level_name
  //         }`;
  //     },
  //   },

  //   {
  //     headerName: "Illnesses",
  //     field: "st_illnesses",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.st_illnesses == null || params.row.st_illnesses == ""
  //           ? "-"
  //           : params.row.st_illnesses
  //         }`;
  //     },
  //   },
  //   {
  //     headerName: "Subject(s)",
  //     field: "subject_name",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.subject_name == null || params.row.subject_name == ""
  //           ? "-"
  //           : params.row.subject_name
  //         }`;
  //     },
  //   },
  //   {
  //     field: "Card Payment Verify",
  //     type: "actions",

  //     //field: "#",
  //     //  type: "actions",
  //     headerName: "Card Payment Verify",
  //     headerClassName: "super-app-theme--header",
  //     width: 170,
  //     //flex: 1,
  //     disableExport: false,
  //     disableColumnFilter: false,
  //     disableColumnMenu: false,
  //     filterable: true,
  //     sortable: true,
  //     headerAlign: "left",
  //     renderCell: (params) => {
  //       const row = params.row;

  //       if (
  //         parseInt(row.stripe_setting) === 1 &&
  //         parseInt(row.online_payment_verified) == 0 && 
  //         parseInt(row.st_card_mail_status) == 0
  //       ) {
  //         return (
  //           <div className="d-flex pad-12">
  //             <Buttonmui
  //               variant="outlined-red"
  //               onClick={() => openPopupSP(row)}
  //               className="primary-blue  btnmr-2 my-auto "
  //             >
  //               Send Verify Link
  //             </Buttonmui>
  //           </div>
  //         );
  //       }else if (
  //         parseInt(row.stripe_setting) === 1 &&
  //         parseInt(row.online_payment_verified) == 0 && 
  //         parseInt(row.st_card_mail_status) == 1
  //       ) {
  //         return (
  //           <div className="d-flex pad-12">
  //             <Buttonmui
  //              variant="outlined"
  //              onClick={() => openPopupSP(row)}
  //              style={{
  //                marginRight: "1rem",
  //                marginTop: "auto",
  //                marginBottom: "auto",
  //                backgroundColor: "#ff9800", // Orange background
  //                color: "white",
  //                border: "1px solid #ff9800",
  //                fontSize: "10px",
  //                textTransform: "none",
  //                minWidth: "max-content",
  //                width: "max-content",
  //                padding: "4px 6px",
  //              }}

  //             >
  //                Resend Verify Link
  //             </Buttonmui>
  //           </div>
  //         );
  //       } else if (
  //         parseInt(row.stripe_setting) === 1 &&
  //         parseInt(row.online_payment_verified) === 1 &&
  //         parseInt(row.card_status) === 1
  //       ) {
  //         return (
  //           // <div className="d-flex pad-12">
  //           //   <p className="text-success mb-0">Active</p>
  //           //   <Buttonmui
  //           //     variant="outlined-red"
  //           //     onClick={() => openPopupCC(row)}
  //           //     className="filled-danger my-2"
  //           //   >
  //           //     Change card
  //           //   </Buttonmui>
  //           // </div>
  //           <div
  //             className="d-flex align-items-center justify-content-between pad-12"
  //             style={{ gap: "8px" }}
  //           >
  //             <p className="text-success mb-0 fs-16">Active </p>

  //           </div>
  //         );
  //       } else if (
  //         parseInt(row.stripe_setting) === 1 &&
  //         parseInt(row.online_payment_verified) === 1 &&
  //         parseInt(row.card_status) === 0
  //       ) {
  //         return (
  //           <div className="d-flex align-items-center justify-content-between pad-12">
  //             <p className="text-danger mb-0 mb-0 fs-16">Inactive</p>
  //             {/* <Buttonmui
  //               variant="outlined-red"
  //               onClick={() => openPopupCC(row)}
  //               className="filled-danger my-2"
  //             >
  //               Change card
  //             </Buttonmui> */}
  //           </div>
  //         );
  //       } else {
  //         return (
  //           <div className="d-flex pad-12">
  //             <p className="text-danger mb-0">Fill a stripe setting</p>
  //           </div>
  //         );
  //       }

  //       //  if(parseInt(row.stripe_setting) === 1 && (row.student_pay_type === null || row.student_pay_type==='')) {
  //       //     return (
  //       //       <div className='d-flex pad-12'>
  //       //         <Buttonmui variant="outlined-red" onClick={() => openPopupSP(row)} className="primary-blue  btnmr-2 my-auto " >
  //       //           Click Payment Link
  //       //         </Buttonmui>
  //       //       </div>
  //       //     );
  //       //   }else if(parseInt(row.stripe_setting) === 1 && row.student_pay_type && parseInt(row.student_pay_type) === 1 && parseInt(row.online_payment_verified) === 1){
  //       //     return ( <div className='d-flex pad-12'>

  //       //       <Buttonmui variant="outlined-red" onClick={() => handleCancelClick(row)} className="filled-danger my-2">Cancel Online</Buttonmui>

  //       //      </div>);
  //       //   }else if(row.student_pay_type && parseInt(row.student_pay_type) === 2){
  //       //     return ( <div className='d-flex pad-12'>

  //       //       <Buttonmui variant="outlined-red" onClick={() => handleCancelOfflineClick(row)} className="filled-danger my-2">Cancel Offline</Buttonmui>

  //       //      </div>);
  //       //   }else if(row.stripe_setting == 0 && (row.student_pay_type === null || row.student_pay_type==='')) {
  //       //     return (
  //       //       <div className='d-flex pad-12'>
  //       //         <Buttonmui variant="outlined-red" onClick={() => handleOfflineClick(row)} className="primary-blue  btnmr-2 my-auto " >
  //       //           Click Offline
  //       //         </Buttonmui>
  //       //       </div>
  //       //     );
  //       //   }else{
  //       //     return (<div className='d-flex pad-12'><p className="text-danger">Fill a stripe setting</p></div>);
  //       //   }
  //     },
  //   },
  //   {
  //     field: "Card Update",
  //     type: "actions",

  //     //field: "#",
  //     //  type: "actions",
  //     headerName: "Card Update",
  //     headerClassName: "super-app-theme--header",
  //     width: 170,
  //     //flex: 1,
  //     disableExport: false,
  //     disableColumnFilter: false,
  //     disableColumnMenu: false,
  //     filterable: true,
  //     sortable: true,
  //     headerAlign: "left",
  //     renderCell: (params) => {
  //       const row = params.row;

  //       if (
  //         parseInt(row.stripe_setting) === 1 &&
  //         parseInt(row.online_payment_verified) === 1 &&
  //         (parseInt(row.card_status) === 1 || parseInt(row.card_status) === 0) &&
  //         parseInt(row.st_card_update_mail_status) == 0
  //       ) {
  //         return (

  //           <div
  //             className="d-flex align-items-center justify-content-between pad-12"
  //             style={{ gap: "8px" }}
  //           >
  //             <Buttonmui
  //               variant="outlined-red"
  //               onClick={() => openPopupCC(row)}
  //               className="primary-blue my-2"
  //             >
  //               Send Card Update Link
  //             </Buttonmui>

  //           </div>
  //         );
  //       } else if (
  //         parseInt(row.stripe_setting) === 1 &&
  //         parseInt(row.online_payment_verified) === 1 &&
  //         (parseInt(row.card_status) === 1 || parseInt(row.card_status) === 0) &&
  //         parseInt(row.st_card_update_mail_status) == 1
  //       ) {
  //         return (

  //           <div
  //             className="d-flex align-items-center justify-content-between pad-12"
  //             style={{ gap: "8px" }}
  //           >
  //             <Buttonmui
  //               variant="outlined-red"
  //               onClick={() => openPopupCC(row)}
  //               style={{
  //                 marginRight: "1rem",
  //                 marginTop: "auto",
  //                 marginBottom: "auto",
  //                 backgroundColor: "#ff9800", // Orange background
  //                 color: "white",
  //                 border: "1px solid #ff9800",
  //                 fontSize: "10px",
  //                 textTransform: "none",
  //                 minWidth: "max-content",
  //                 width: "max-content",
  //                 padding: "4px 6px",
  //               }}
  //             >
  //               Resend Card Update Link
  //             </Buttonmui>

  //           </div>
  //         );
  //       } else {
  //         return (
  //           <div className="d-flex pad-12"> -
  //             {/* <p className="text-danger mb-0">Fill a stripe setting</p> */}
  //           </div>
  //         );
  //       }


  //     },
  //   },
  //   // {
  //   //   headerName: 'Subscription Plan',
  //   //   field: "Subscription",
  //   //   headerClassName: "super-app-theme--header",
  //   //   flex: 1,
  //   //   valueGetter: (params) => {
  //   //     return `${params.row.stripe_acount > 0 && params.row.stp_product_name && params.row.ss_price  ? params.row.stp_product_name+'($'+params.row.ss_price+')' : '-'}`;
  //   //   },

  //   // },
  //   {
  //     headerName: "Stripe Status",
  //     field: "stripe_status",
  //     headerClassName: "super-app-theme--header",
  //     flex: 1,
  //     minWidth: 150,
  //     valueGetter: (params) => {
  //       return `${params.row.stripe_status == null || params.row.stripe_status == ""
  //           ? "-"
  //           : params.row.stripe_status
  //         }`;
  //     },
  //   },
  //   {
  //     field: "Login Details",
  //     type: "actions",

  //     //field: "#",
  //     //  type: "actions",
  //     headerName: "Login",
  //     headerClassName: "super-app-theme--header",
  //     width: 170,
  //     //flex: 1,
  //     disableExport: false,
  //     disableColumnFilter: false,
  //     disableColumnMenu: false,
  //     filterable: true,
  //     sortable: true,
  //     headerAlign: "left",
  //     renderCell: (params) => {
  //       const row = params.row;

  //       if (
  //         parseInt(row.is_login_mail) === 1 
  //       ) {
  //         return (

  //           <div className="d-flex pad-12">
  //            <Buttonmui
  //                 variant="outlined"
  //                 onClick={() => openPopupLogin(row)}
  //                 style={{
  //                   marginRight: "0.5rem",
  //                   marginTop: "auto",
  //                   marginBottom: "auto",
  //                   backgroundColor: "#28a745", // Green background
  //                   color: "white",
  //                   border: "1px solid #28a745",
  //                   fontSize: "10px",
  //                   textTransform: "none",
  //                   minWidth: "max-content",
  //                   width: "max-content",
  //                   padding: "4px 6px",
  //                 }}
  //               >
  //                 Sent Login Details
  //               </Buttonmui>

  //           </div>
  //         );
  //       }  else {
  //         return (
  //           <div className="d-flex pad-12">
  //             <Buttonmui
  //               variant="outlined"
  //               onClick={() => openPopupLogin(row)}
  //               className="primary-blue  btnmr-2 my-auto"
  //             >
  //               Send Login Details
  //             </Buttonmui>
  //         </div>
  //         );
  //       }


  //     },
  //   },
  //   {
  //     field: "actions",
  //     type: "actions",

  //     //field: "#",
  //     //  type: "actions",
  //     headerName: "Action",
  //     headerClassName: "super-app-theme--header",
  //     width: 250,
  //     //flex: 1,
  //     disableExport: false,
  //     disableColumnFilter: false,
  //     disableColumnMenu: false,
  //     filterable: true,
  //     sortable: true,
  //     headerAlign: "left",
  //     valueGetter: (params) => {
  //       return `${parseInt(params.row.visibility) == 1 ? "Active" : "Inactive"
  //         }`;
  //     },
  //     renderCell: (params) => {
  //       const row = params.row;

  //       if (row.pay_gateway_response_code == "Authorised") {
  //         return (
  //           <div className="d-flex  pad-12">
  //             <p>Completed</p>
  //             {parseInt(row.visibility) == 1 ? (
  //               <span
  //                 className="active-btn my-auto cursor-pointer"
  //                 onClick={() => handleDeleteClick(row)}
  //               >
  //                 <DoneIcon className="icon-blue btn-icon me-1" />
  //                 Active
  //               </span>
  //             ) : (
  //               <span
  //                 className="deactive-btn my-auto cursor-pointer"
  //                 onClick={() => handleVisibleClick(row)}
  //               >
  //                 <CloseIcon className=" btn-icon me-1" />
  //                 Inactive
  //               </span>
  //             )}
  //           </div>
  //         );
  //       } else {
  //         return (
  //           <div className="d-flex pad-12">
  //             {/* <Buttonmui
  //               variant="outlined-red"
  //               onClick={() => openPopupGP(row)}
  //               className="primary-blue  btnmr-2 my-auto "
  //             >
  //               Send Enrolment
  //             </Buttonmui> */}
  //             {parseInt(row.st_enroll_status) === 1 && (
  //               <Buttonmui
  //                 variant="outlined"
  //                 onClick={() => openPopupGP(row)}
  //                 style={{
  //                   marginRight: "1rem",
  //                   marginTop: "auto",
  //                   marginBottom: "auto",
  //                   backgroundColor: "#ff9800", // Orange background
  //                   color: "white",
  //                   border: "1px solid #ff9800",
  //                   fontSize: "10px",
  //                   textTransform: "none",
  //                   minWidth: "max-content",
  //                   width: "max-content",
  //                   padding: "4px 6px",
  //                 }}
  //               >
  //                 Enrolment Sent
  //               </Buttonmui>
  //             )}

  //             {parseInt(row.st_enroll_status) === 2 && (
  //               <Buttonmui
  //                 variant="outlined"
  //                 onClick={() => openPopupGP(row)}
  //                 style={{
  //                   marginRight: "0.5rem",
  //                   marginTop: "auto",
  //                   marginBottom: "auto",
  //                   backgroundColor: "#28a745", // Green background
  //                   color: "white",
  //                   border: "1px solid #28a745",
  //                   fontSize: "10px",
  //                   textTransform: "none",
  //                   minWidth: "max-content",
  //                   width: "max-content",
  //                   padding: "4px 6px",
  //                 }}
  //               >
  //                 Enrolment Received
  //               </Buttonmui>
  //             )}
  //             {parseInt(row.st_enroll_status) !== 1 &&
  //               parseInt(row.st_enroll_status) !== 2 && (
  //                 <Buttonmui
  //                   variant="outlined"
  //                   onClick={() => openPopupGP(row)}
  //                   className="primary-blue  btnmr-2 my-auto"
  //                 >
  //                   Send Enrolment
  //                 </Buttonmui>
  //               )}
  //             {parseInt(row.visibility) == 1 ? (
  //               <span
  //                 className="active-btn my-auto cursor-pointer"
  //                 onClick={() => handleDeleteClick(row)}
  //               >
  //                 <DoneIcon className="icon-blue  btn-icon me-1" />
  //                 Active
  //               </span>
  //             ) : (
  //               <span
  //                 className="deactive-btn my-auto cursor-pointer"
  //                 onClick={() => handleVisibleClick(row)}
  //               >
  //                 <CloseIcon className=" btn-icon me-1" />
  //                 Inactive
  //               </span>
  //             )}

  //             {/* <Buttonmui variant="outlined-red" onClick={() => openPopupGP(row)} className="primary-blue  btnmr-2 my-auto">Send Enrolment </Buttonmui> */}
  //           </div>
  //         );
  //       }
  //     },
  //   },
  // ];


  function onSubmitStudentLevelUpdateRequest() {
    setStudentLevelRequestSubmitting(true);

    axios
      .post(BASE_URL + "API/api_index.php", {
        security_key: security_key,
        fk_cent_key: sessionStorage.getItem("key"),
        mode: "centreStudentYearLevelUpdate",
        type: type,
        country_id: sessionStorage.getItem('country_code'),
      })
      .then((responseUpdate) => {
        if (responseUpdate.data.data == 1) {
          setShowPopupLevel(false);
          setStudentLevelRequestSubmitting(false);

          // Handle the successful response here
          toast.success("Success! students year level updated", {
            autoClose: 700, // 3 seconds in this example
          });

          // handleTutSessClick(data_forfeit);
          fetchData()
        } else {
          toast.error("Failure! Unable to update student year level. Try again later", {
            autoClose: 700, // 3 seconds in this example
          });
          setStudentLevelRequestSubmitting(false);
        }
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        toast.error("Failure! Unable to update student year level. Try again later", {
          autoClose: 700, // 3 seconds in this example
        });
        setStudentLevelRequestSubmitting(false);
      });
  }

  return (
    <>
      <ToastContainer position="top-center" />
      <Modal
        show={ShowPopupLevel}
        variant="danger"
        style={{ zIndex: "1111" }}
      >
        <Modal.Header>Year Level</Modal.Header>

        <Modal.Body>
          <p>Are you sure? You want to student move to {type == '1' ? 'next' : 'previous'} year level?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="mx-auto d-flex gap-2">
            <Button
              variant="contained"
              className="primary-gray"
              onClick={() => setShowPopupLevel(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              className="primary-filled "
              disabled={isStudentLevelRequestSubmitting}
              onClick={() => onSubmitStudentLevelUpdateRequest()}
            >
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="page-wrapper">
        {/* --------------Page Start--------------- */}

        {/* --------------Section Start--------------- */}

        <div className="mb-3 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="page-title"> Students Year List </h5>

            <div role="presentation">
              <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                <NavLink underline="hover" color="inherit" to="/calendar">
                  {" "}
                  Home
                </NavLink>
                <Typography color="text.primary">Students Year List</Typography>
              </Breadcrumbs>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <NavLink
              className="primary-filled rounded-10 p-2 me-2"
              to="#"
              onClick={() => { openPopup(1) }}
            >
              All Students Move to Next Level
            </NavLink>
            {records && records.length > 0 && records[0].previous_count_year_log < records[0].next_count_year_log ? <NavLink
              className="primary-filled rounded-10 p-2"
              to="#"
              onClick={() => { openPopup(2) }}
            >
              All Students Move to previous Level
            </NavLink> : null}
          </div>
        </div>
        <Card className="my-card p-1 bg-white">
          <Card.Body>

            {/* -------------Content Start--------------- */}

            <Row>
              <Col xs="12">
                <div className="">
                  <Row className="justify-content-center">

                    {/* --------------Table Content Start--------------- */}
                    <Col sm={12}>

                      {records && records.length > 0 && records?.[0]?.sl_datetime ? (
                        <div className="text-danger p-2 d-flex justify-content-end">
                          <p className="text-danger mb-2">Year Level Latest updated on{" "}
                            {Moment(records[0].sl_datetime, "YYYY-MM-DD HH:mm:ss").format("DD MMMM YYYY hh:mm A")}</p>
                        </div>
                      ) : null}
                      <Box
                        sx={{
                          height: hasRows ? "auto" : 200,
                          maxHeight: "calc(100vh - 270px)",
                          width: "100%",
                          "& .actions": {
                            color: "text.secondary",
                          },
                          "& .textPrimary": {
                            color: "text.primary",
                          },
                          "& .super-app-theme--header": {
                            backgroundColor: "#f4f4f4",
                          },
                          "& .MuiDataGrid-row": {
                            border: "1px solid #eff0f2",
                          },
                          "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus":
                          {
                            outline: "none !important",
                          },
                          "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
                          {
                            outline: "none !important",
                          },
                        }}
                        style={{ width: "100%" }}
                      >
                        <DataGrid
                          sx={{
                            // disable cell selection style
                            ".MuiDataGrid-cell:focus": {
                              outline: "none",
                            },
                            // pointer cursor on ALL rows
                            "& .MuiDataGrid-row:hover": {
                              cursor: "pointer",
                            },
                            maxHeight: "calc(100vh - 270px)",
                          }}
                          //sx={{ border: "none", m: 2 }}
                          slots={{
                            loadingOverlay: LinearProgress,
                            //noRowsOverlay: CustomNoRowsOverlay,
                            toolbar: GridToolbar,
                            // toolbar: EditToolbar,
                          }}
                          slotProps={{
                            toolbar: {
                              csvOptions: { fileName: "StudentList" },
                              printOptions: {
                                pageStyle: `@media print {
                                      @page {
                                        size: A4 landscape;
                                        margin: 0;
                                      }
                                    }`,
                                disableToolbarButton: true,
                                hideFooter: true,
                                hideToolbar: true,
                                fileName: "StudentList",
                              },
                              records,
                              showQuickFilter: true,
                            },
                          }}
                          showQuickFilter={true}
                          pagination={false}
                          hideFooterPagination
                          hideFooter
                          loading={loading}
                          rows={records.map((row, index) => ({
                            ...row,
                            id: `row-${index}`,
                          }))}
                          columns={columns}
                          rowHeight={60}
                          density="compact"
                          disableRowSelectionOnClick
                          showCellVerticalBorder={true}
                          showColumnVerticalBorder={true}
                          // editMode="row"
                          onRowClick={(params) =>
                            handleStudentViewClick(params.row)
                          }
                        // isRowSelectable={(params: GridRowParams) => handleStudentViewClick(params.row)}
                        // rowModesModel={rowModesModel}
                        // onRowModesModelChange={handleRowModesModelChange}
                        // // processRowUpdate={processRowUpdate}
                        // getRowId={(row) => row.pk_student_id}
                        />
                      </Box>

                    </Col>
                    {/* --------------Table Content Start--------------- */}
                  </Row>
                </div>
              </Col>
            </Row>

            {/* --------------Content End--------------- */}

          </Card.Body>
        </Card>

        {/* --------------Section End--------------- */}

        {/* --------------Page End--------------- */}
      </div>
    </>
  );
};

export default StudentYearLevel;
